import { z } from 'zod';
import { PlayerColor } from '../PlayerState.ts';
import { victoryPointStateSchema } from '../VictoryPointState.ts';
import { validateState } from '../ValidateState.ts';
// Don't change order. Used for analytics
export var PlayerTitleEnum = /*#__PURE__*/ function(PlayerTitleEnum) {
    PlayerTitleEnum[PlayerTitleEnum["Monopolist"] = 0] = "Monopolist";
    PlayerTitleEnum[PlayerTitleEnum["Juggernaut"] = 1] = "Juggernaut";
    return PlayerTitleEnum;
}({});
export const endGamePlayerStateSchema = z.object({
    color: z.enum(PlayerColor),
    rank: z.number().int().positive(),
    victoryPoints: victoryPointStateSchema,
    winningPlayer: z.boolean(),
    hasResigned: z.literal(true).optional(),
    title: z.enum(PlayerTitleEnum).optional()
}).strict();
export function validateEndGamePlayerState(data) {
    return validateState(endGamePlayerStateSchema, data);
}
